/**
 * Configuración de los tableros del módulo aéreo. Es del aéreo: no se
 * comparte con el LCL, que tiene la suya en `lcl-requests/utils`.
 */
import {
  ClipboardList,
  Package,
  Truck,
  ShieldCheck,
  CheckCheck,
  FolderArchive,
  UserX,
  Ban,
} from 'lucide-react';

export const ITEMS_PER_PAGE = 10;

/** Días sin movimiento a partir de los cuales una cotización se ve "Vencida". */
export const VENCIDA_DIAS = 7;

export const SUBESTADOS_COTIZACIONES = [
  { value: 'Borrador', label: 'Borrador' },
  { value: 'Enviada', label: 'Enviada' },
  { value: 'Esperando respuesta', label: 'Esperando respuesta' },
  { value: 'Vencida', label: 'Vencida' },
];

export const SUBESTADOS_EN_CURSO = [
  { value: 'Confirmada', label: 'Confirmada', icon: ClipboardList },
  { value: 'Documentacion', label: 'Documentación', icon: Package },
  { value: 'En transito', label: 'En tránsito', icon: Truck },
  { value: 'En aduana', label: 'En aduana', icon: ShieldCheck },
];

export const SUBESTADOS_FINALIZADAS = [
  { value: 'Cerrada', label: 'Cerrada', icon: CheckCheck },
  { value: 'Archivada', label: 'Archivada', icon: FolderArchive },
];

export const SUBESTADOS_RECHAZADAS = [
  { value: 'Cancelada por cliente', label: 'Cancelada por cliente', icon: UserX },
  { value: 'Anulada por operador', label: 'Anulada por operador', icon: Ban },
];

export const SUBESTADO_BADGE = {
  Borrador: 'bg-slate-100 text-slate-700 border-slate-200',
  Enviada: 'bg-blue-100 text-blue-700 border-blue-200',
  'Esperando respuesta': 'bg-amber-100 text-amber-800 border-amber-200',
  Vencida: 'bg-rose-100 text-rose-700 border-rose-200',
  Confirmada: 'bg-sky-100 text-sky-700 border-sky-200',
  Documentacion: 'bg-amber-100 text-amber-800 border-amber-200',
  'En transito': 'bg-indigo-100 text-indigo-700 border-indigo-200',
  'En aduana': 'bg-purple-100 text-purple-700 border-purple-200',
  Cerrada: 'bg-emerald-100 text-emerald-800 border-emerald-200',
  Archivada: 'bg-slate-200 text-slate-700 border-slate-300',
  'Cancelada por cliente': 'bg-rose-100 text-rose-800 border-rose-200',
  'Anulada por operador': 'bg-slate-200 text-slate-700 border-slate-300',
};

export const daysSince = (v) => {
  if (!v) return 0;
  const d = new Date(v);
  if (Number.isNaN(d.getTime())) return 0;
  return Math.floor((Date.now() - d.getTime()) / (1000 * 60 * 60 * 24));
};

/**
 * Sub-estado efectivo en Cotizaciones: una solicitud enviada o esperando
 * respuesta hace más de `VENCIDA_DIAS` se muestra como "Vencida".
 */
export const subEstadoCotizacion = (r) => {
  if (r.subEstado && r.subEstado !== 'Vencida') {
    if (r.subEstado === 'Enviada' || r.subEstado === 'Esperando respuesta') {
      return daysSince(r.updatedAt || r.createdAt) > VENCIDA_DIAS ? 'Vencida' : r.subEstado;
    }
    return r.subEstado;
  }
  return r.subEstado || 'Borrador';
};
